import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FieldArray, Field, reduxForm } from "redux-form";
import { GenomeEditDetectionNhej } from "./GenomeEditDetectionNhej";
import { GenomeEditDetectionHDR } from "./GenomeEditDetectionHDR";

import GenomeEditDetectionDescription from "./GenomeEditDetection-Description.jsx";
import AppWrapper from "../../Common/AppWrapper/index.jsx";
import {
  RenderInput,
  RenderSelect,
  RenderRadio,
} from "../../Common/InputComponents/Inputs.jsx";
import {
  tooltipReferenceGenome,
  tooltipGenomeEditDetectionHdrContextSequence,
  tooltipGenomeEditDetectionHdrDonorSequence,
  tooltipGenomeEditDetectionSpecies,
  tooltipGenomeEditDetectionNhejContextSequence,
  tooltipGenomeEditDetectionNhejDonorPresent,
} from "../../Common/Misc/Tooltips.jsx";
import {
  required,
  maxLength17,
  minLength5,
  hasValidWhitespace,
  configureNhejContextSequenceValidator,
  configureHdrContextSequenceValidator,
  validateGenomeEditDonorSequence,
} from "../../../util/validations.js";
import { firstSeventeen, removeSpaces } from "../../../util/format";
import * as assayActions from "../../../actions/assays.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import "../AssayCreate.scss";
import _ from "underscore";

const genomeOptions = [
  "Homo sapiens",
  "Mus musculus",
  "Rattus norvegicus",
  "Other",
];

const sequenceMatches = (species) => {
  return (
    <span>
      The sequence being edited <strong>matches</strong> the {species} reference
      genome
    </span>
  );
};

const sequenceVariation = (species) => {
  return (
    <span>
      The sequence being edited <strong>is a variation</strong> of the {species}{" "}
      reference genome
    </span>
  );
};

const styles = (theme) => ({
  progress: {
    marginLeft: theme.spacing(2),
  },
});

export class GenomeEditDetectionForm extends React.Component {
  componentWillUnmount() {
    const { actions } = this.props;
    //actions.clearMessage();
  }

  onSubmit = (values, dispatch) => {
    return dispatch(assayActions.processGetNewAssays(values));
  };

  render() {
    const {
      formObj,
      classes,
      handleSubmit,
      pristine,
      submitting,
      validatedAssayDetails,
    } = this.props;

    const selectedTargetBy =
      formObj && formObj.values && formObj.values.targetBy;

    const btnSubmitClass = classNames({
      "btn-submit float-right": !submitting,
      "btn-submit float-right btn-submitting": submitting,
    });

    return (
      <div id="genomeeditdetection-form">
        <div className="row">
          <div className="col">
            <label>Assay Type: &nbsp;</label>
            <div className="form-check form-check-inline">
              <Field
                className="form-check-input"
                component="input"
                type="radio"
                name="targetBy"
                value="NhejGenomeEdit"
              />
              <label className="form-check-label" htmlFor="inlineCheckbox1">
                NHEJ edit
              </label>
            </div>
            <div className="form-check form-check-inline">
              <Field
                className="form-check-input"
                component="input"
                type="radio"
                name="targetBy"
                value="HdrGenomeEdit"
              />
              <label className="form-check-label" htmlFor="inlineCheckbox2">
                HDR edit
              </label>
            </div>
          </div>
        </div>

        <div className="inputs">
          {selectedTargetBy && selectedTargetBy === "NhejGenomeEdit" && (
            <FieldArray
              name="genomeEditDetectionNhej"
              custom={this.props}
              component={GenomeEditDetectionNhej}
            />
          )}
          {selectedTargetBy && selectedTargetBy === "HdrGenomeEdit" && (
            <FieldArray
              name="genomeEditDetectionHDR"
              custom={this.props}
              component={GenomeEditDetectionHDR}
            />
          )}
        </div>

        <div className="row">
          <div className="col">
            <button
              type="button"
              className={btnSubmitClass}
              disabled={
                (pristine || submitting) && _.isEmpty(validatedAssayDetails)
              }
              onClick={handleSubmit(this.onSubmit.bind(this))}
            >
              {!submitting ? "SUBMIT" : "SUBMITTING"}
              {submitting && (
                <CircularProgress
                  className={classes.progress}
                  size={20}
                  thickness={4}
                />
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

GenomeEditDetectionForm.propTypes = {
  formObj: PropTypes.object,
  handleSubmit: PropTypes.func,
  pristine: PropTypes.bool,
  actions: PropTypes.object,
};

const epochDate = new Date().getTime();

const validateNhej = (frmValues) => {
  let errors = { genomeEditDetectionNhej: [], genomeEditDetectionHDR: [] };
  const { targetBy } = frmValues;
  let values = {};
  let formName = "";
  if (targetBy === "NhejGenomeEdit") {
    values = frmValues && frmValues.genomeEditDetectionNhej;
    formName = "genomeEditDetectionNhej";
  } else {
    values = frmValues && frmValues.genomeEditDetectionHDR;

    formName = "genomeEditDetectionHDR";
  }

  _.map(values, (value, index) => {
    let genomeIsOther = value && value.species === "Other" ? true : false;
    let donorSequence = value && value.donorSequence;
    let donorPresent = (value && value.donorPresent) || "No";
    let species = value && value.species;
    let sequence = value && value.contextSequence;
    let assayTargetName = value && value.assayTargetName;
    let assayType = value && value.assayType;
    let error = {};
    let tempError = {};
    const donorSequenceErrorMessage =
      "The minimum length needed for Donor Sequence is 50 characters!";
    error["assayTargetName"] =
      _.isNull(assayTargetName) ||
      assayTargetName == undefined ||
      assayTargetName === ""
        ? "Required!"
        : undefined;
    error["donorSequence"] =
      (donorPresent && donorPresent === "Yes" && _.isNull(donorSequence)) ||
      donorSequence === null ||
      donorSequence === undefined
        ? "There was no sequence provided. Please provide a sequence"
        : undefined;
    if (
      (donorPresent && donorPresent === "Yes" && !_.isNull(donorSequence)) ||
      donorSequence !== null ||
      donorSequence !== undefined
    ) {
      error["donorSequence"] = validateGenomeEditDonorSequence(donorSequence);
    }

    if (assayType && assayType === "NhejGenomeEdit") {
      tempError = configureNhejContextSequenceValidator(
        genomeIsOther,
        donorSequence,
        sequence
      );
      error["contextSequence"] =
        (!_.isEmpty(tempError) && !_.isNull(tempError) && new Set(tempError)) ||
        undefined;
    }
    if (assayType && assayType === "HdrGenomeEdit") {
      tempError = configureHdrContextSequenceValidator(
        genomeIsOther,
        donorSequence,
        sequence
      );
      error["contextSequence"] =
        (!_.isEmpty(tempError) && !_.isNull(tempError) && tempError) ||
        undefined;
    }

    errors[formName].push(error);
  });

  if (!_.isEmpty(errors) && !_.isNull(errors)) {
    return errors;
  } else {
    return undefined;
  }
};

const stateToProps = (state) => ({
  formObj: state.form["frmGenomeEditDetection"],
  initialValues: {
    applicationType: "GenomeEditDetection",
    targetBy: "NhejGenomeEdit",
    genomeEditDetectionNhej: [
      {
        assayType: "NhejGenomeEdit",
        assayTargetName: "",
        species: "Homo sapiens",
        created_at: epochDate,
      },
    ],
    genomeEditDetectionHDR: [
      {
        assayType: "HdrGenomeEdit",
        assayTargetName: "",
        species: "Homo sapiens",
        created_at: epochDate,
      },
    ],
  },
  validatedAssayDetails:
    (state.assays &&
      state.assays.validatedAssayDetails &&
      state.assays.validatedAssayDetails.data) ||
    {},
});

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(assayActions, dispatch),
});

GenomeEditDetectionForm = reduxForm({
  form: "frmGenomeEditDetection",
  enableReinitialize: true,
  validate: validateNhej,
})(GenomeEditDetectionForm);

GenomeEditDetectionForm = withStyles(styles)(GenomeEditDetectionForm);

GenomeEditDetectionForm = connect(
  stateToProps,
  dispatchToProps
)(GenomeEditDetectionForm);

const GenomeEditDetection = () => {
  return (
    <AppWrapper
      id="genomeeditdetection"
      pageTitle="Genome Edit Detection"
      pageKeywords="Genome Edit Detection, design engine, custom assays"
      pageDescription="ddPCR Genome Edit Detection Assays offer a fast, precise, simple, and cost-effective method for detection of HDR and NHEJ genome editing events created using nucleases like CRISPR-Cas9."
    >
      <div id="bg">
        <div id="bg-inner"></div>
      </div>
      <div className="container main-content">
        <div className="hero">
          <h2 className="h4">ASSAY DESIGN ENGINE</h2>
          <h1>Genome Edit Detection</h1>
        </div>

        <GenomeEditDetectionForm />
        <GenomeEditDetectionDescription />
      </div>
    </AppWrapper>
  );
};

export default GenomeEditDetection;
